// KL - aircond chemical overhaul.
const content = {
    slug: 'aircond-chemical-overhaul',
    title: (c) => `Aircond Chemical Overhaul KL from ${c.money(c.tables.chemicalOverhaul[0].wall)} | Full Dismantle`,
    description: (c) =>
        `Aircond chemical overhaul in KL from ${c.money(c.tables.chemicalOverhaul[0].wall)}: the unit is taken down, dismantled and every part washed. For old, smelly or neglected units.`,
    eyebrow: 'KL · Chemical overhaul',
    h1: 'Aircond Chemical Overhaul in KL',
    lead: (c) =>
        `For units that have gone years without a proper clean, or that still smell after a chemical wash. The unit comes off the wall and every part is washed separately - ${c.money(c.tables.chemicalOverhaul[0].wall)} for one wall-mounted unit.`,
    image: 'blog/living/air-conditioner-blower.jpg',
    imageAlt: 'Aircond blower wheel removed during a chemical overhaul',
    facts: ['Full dismantle', '2-3 hours per unit', 'For neglected units'],
    priceTitle: 'Chemical overhaul prices',
    priceIntro: 'Priced per unit. Most overhauls are on wall-mounted units in bedrooms that run every night.',
    panel: { type: 'servicing', services: ['chemicalOverhaul'], defaultMount: 'Wall' },
    sections: [
        {
            title: 'When to choose an overhaul',
            cards: [
                { title: 'Just bought or rented', body: 'You moved into a condo or house and nobody knows when the units were last serviced.' },
                { title: 'Smell keeps coming back', body: 'A chemical wash helped for a few weeks, then the smell returned - mould is hiding behind the coil and in the casing.' },
                { title: 'Noisy blower', body: 'The fan wheel rattles or wobbles because grime has built up unevenly on its blades.' },
            ],
        },
        {
            // Target of the hero card's Service Details link
            id: 'included',
            title: 'What happens in an overhaul',
            tone: 'muted',
            steps: [
                { title: 'Unit removed', body: 'The indoor unit is lifted off its bracket. The pipes stay connected, so the gas is not released.' },
                { title: 'Taken apart', body: 'Casing, drain tray, louvres and blower wheel come off and are soaked and scrubbed one by one.' },
                { title: 'Coil chemical-washed', body: 'Both faces of the coil are treated - including the back, which a normal wash can\'t reach.' },
                { title: 'Rebuilt and tested', body: 'Everything goes back together, the drain is flushed, and the unit is tested for temperature and noise.' },
            ],
        },
        {
            title: 'Old unit? Compare before you overhaul',
            paragraphs: [
                'If your unit is more than ten years old, non-inverter and uses R22 gas, an overhaul will restore cooling but not efficiency. A new inverter unit can cut that room\'s share of your TNB bill noticeably. The technician gives you an honest view on the day.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is aircond chemical overhaul in KL?',
            answer: (c) => `${c.money(c.tables.chemicalOverhaul[0].wall)} for one wall-mounted unit, ${c.money(c.tables.chemicalOverhaul[1].wall)} for two, and ${c.money(c.tables.chemicalOverhaul[0].ducted)} for a ceiling cassette.`,
        },
        {
            question: 'Will my aircond lose gas during an overhaul?',
            answer: 'No - the pipes stay connected and the system stays sealed. If the unit was already low on gas, the technician tells you and quotes a top up.',
        },
        {
            question: 'How often is an overhaul needed?',
            answer: 'Every two to three years at most, for units that also get regular general services. Yearly overhauls mean the regular servicing is too infrequent.',
        },
    ],
    schema: {
        name: 'Aircond Chemical Overhaul in Kuala Lumpur',
        serviceType: 'Air conditioner chemical overhaul',
        offers: (c) => [
            { name: 'Chemical overhaul, 1 unit', price: c.tables.chemicalOverhaul[0].wall },
            { name: 'Chemical overhaul, 2 units', price: c.tables.chemicalOverhaul[1].wall },
            { name: 'Chemical overhaul, 1 ceiling cassette', price: c.tables.chemicalOverhaul[0].ducted },
        ],
    },
}

export default content
